import { useParams } from "react-router";
import { DaUnableToLogin } from "../../components/DaUnableToLogin/DaUnableToLogin";

function DaUnableToLoginPage() {
  const { tenant } = useParams();
  const theme = `${tenant}-theme`;
  return (
    <div className={theme} data-testid="theme-name">
      {tenant === "ms1" ? <DaUnableToLogin /> : null}
    </div>
  );
}

export default DaUnableToLoginPage;
